import { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer"
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { GreenButton, GreyButton } from '../../components/buttons.js';
import Loader from '../../components/Loader.jsx';
import Error from '../../components/Error.jsx';
import { useSelector } from "react-redux";


// Questa è la pagina a cui si approda confermando gli acquisti nella pagina CartRecap.jsx
// Prended i dati del carrello da cartSlice (Reindirizzare in Carello o Shop in caso di refresh)
const ConfirmOrderRequest = () => {
    // Verifico che l'utente provenga dalla pagina di checkout
    const location = useLocation();
    console.log('location.state: ', location.state)

    // Catturo i dati dal carrello e userId
    const { id } = useSelector(state => state.user);
    const { data } = useSelector(state => state.cart);

    // Invio i dati in backend
    const [sendDataStatus, setSendDataStatus] = useState('idle');
    const [sendDataError, setSendDataError] = useState(false);
    const token = localStorage.getItem('ticino-wild-token');
    const sendData = async () => {
        setSendDataStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/get-purchase`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'POST', headers, body: JSON.stringify({ userId: id, productsArray: data }) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setSendDataStatus('succeeded');
                console.log('result: ', result);
                window.location.href = result.url;
            } else {
                const error = await response.json();
                throw error
            }
        } catch (error) {
            console.error(error);
            setSendDataError(error.message || "Errore nell'invio della richiesta d'acquisto.");
            setSendDataStatus('failed')
        }
    }
    useEffect(() => {
        if (id, data) sendData()
    }, [id, data])
    return (
        <PageContainer items="center">
            <div className="min-h-96 flex flex-col gap-4 justify-center items-center">
                {sendDataStatus === 'loading' && <Loader />}
                {sendDataStatus === 'failed' && sendDataError && <Error text={sendDataError} message="Torna allo shop e riprova" />}
            </div>
        </PageContainer>
    )
}
export default ConfirmOrderRequest